/**
 * FAQ — accordion-style. Each item opens independently via the native
 * `<details>` element — zero JS, fully accessible by default, and
 * search-engine-friendly (rendered closed but text is in the DOM).
 */
import { useTranslation } from 'react-i18next'
import { ChevronDown } from 'lucide-react'
import { Header } from './Features'

const KEYS = [
  'custody', 'exchanges', 'risk', 'strategies', 'approval', 'stop',
] as const

export function Faq() {
  const { t } = useTranslation('landing')
  return (
    <section
      id="faq"
      className="px-6 py-20 md:py-28 border-t border-line scroll-mt-16"
    >
      <div className="max-w-3xl mx-auto">
        <Header
          label={t('faq.section_label')}
          title={t('faq.title')}
        />

        <div className="mt-10 divide-y divide-line border-y border-line">
          {KEYS.map((k) => (
            <details key={k} className="group py-5 cursor-pointer">
              <summary className="flex items-start gap-4 list-none">
                <span className="flex-1 text-base font-medium tracking-tight">
                  {t(`faq.items.${k}.q`)}
                </span>
                <ChevronDown
                  size={18}
                  className="text-textDim shrink-0 mt-1 transition-transform group-open:rotate-180"
                />
              </summary>
              <p className="mt-3 text-sm text-textDim leading-relaxed pr-8">
                {t(`faq.items.${k}.a`)}
              </p>
            </details>
          ))}
        </div>
      </div>
    </section>
  )
}
